import React, { useState } from "react";
import styles from "./Contact.module.css";
import LineAnimation from "../../components/lineAnimations/LineAnimation";
import LineAnimationTwo from "../../components/lineAnimationsTwo/LineAnimationTwo";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Create mailto link with form data
    const mailtoLink = `mailto:info@boldstudio.design?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(
      `Emri: ${formData.name}\nEmail: ${formData.email}\nTelefoni: ${formData.phone}\n\nMesazhi:\n${formData.message}`
    )}`;
    window.location.href = mailtoLink;
  };

  return (
    <>
      <div className={styles.pageBck}>
        <LineAnimation />
        <LineAnimationTwo />
        <div className={styles.pageBanner}>
          <h1>Kontakti</h1>
          <span>GET IN TOUCH</span>
          <p>
            A keni një projekt në mendje? Jemi këtu për t'ju ndihmuar të ktheni idetë tuaja në realitet. 
            Na kontaktoni sot dhe le të fillojmë bashkëpunimin!
          </p>
        </div>
      </div>

      <div className={styles.contactSection}>
        <div className="subContainer">
          <div className={styles.contactGrid}>
            {/* Contact Information */}
            <div className={styles.contactInfo}>
              <h2>Na Kontaktoni</h2>
              <p className={styles.subtitle}>
                Jemi të gatshëm të dëgjojmë nga ju. Mos hezitoni të na kontaktoni për çdo pyetje apo kërkesë.
              </p>

              <div className={styles.infoItem}>
                <div className={styles.iconWrapper}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div>
                  <h3>Email</h3>
                  <a href="mailto:info@boldstudio.design">info@boldstudio.design</a>
                </div>
              </div>

              <div className={styles.infoItem}>
                <div className={styles.iconWrapper}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                </div>
                <div>
                  <h3>Telefoni</h3>
                  <a href="tel:+38349123456">+383 49 123 456</a>
                </div>
              </div>

              <div className={styles.infoItem}>
                <div className={styles.iconWrapper}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div>
                  <h3>Adresa</h3>
                  <p>Prishtinë, Kosovë</p>
                </div>
              </div>

              <div className={styles.infoItem}>
                <div className={styles.iconWrapper}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                </div>
                <div>
                  <h3>Orari i Punës</h3>
                  <p>E Hënë - E Premte: 9:00 - 17:00</p>
                  <p>E Shtunë: 9:00 - 13:00</p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className={styles.contactForm}>
              <h2>Dërgo një Mesazh</h2>
              <form onSubmit={handleSubmit}>
                <div className={styles.formGroup}>
                  <label htmlFor="name">Emri i Plotë *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Shkruani emrin tuaj"
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="email@example.com"
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="phone">Telefoni</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+383 XX XXX XXX"
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="subject">Subjekti *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="Shkruani subjektin"
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="message">Mesazhi *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Shkruani mesazhin tuaj këtu..."
                  />
                </div>

                <button type="submit" className={styles.submitBtn}>
                  Dërgo Mesazhin
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.mapSection}>
        <iframe
          title="Bold Studio Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2935.8558849893495!2d21.163192776191436!3d42.66291671617438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13549ee605110927%3A0x9365bfdf385eb95a!2sPristina!5e0!3m2!1sen!2s!4v1696524000000!5m2!1sen!2s"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </>
  );
};

export default Contact;

